



























































import { Component, Vue, Prop } from "vue-property-decorator";
import Title from "./title.vue";
import SubTitle from "./title-sub.vue";
@Component({
  components: {
    Title,
    SubTitle,
  },
})
export default class Name extends Vue {
  @Prop()
  private content: any;
  @Prop()
  private index: any;
  @Prop()
  private source: any; //dialog,审核修改弹框;renkouxue,人口学和受试者信息;
  private ifShowDialog: any = false;
  private zhengzhuangfenjiData: any = [];
  private get c() {
    return JSON.parse(JSON.stringify(this.content));
  }
  private selectChange(e: any) {
    this.$forceUpdate();
  }
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  private valueChange(e?: any) {
    if (this.source === "dialog") {
      this.$emit("updateDialog", this.c);
    } else {
      this.$emit("update", this.c);
    }
  }
  private change() {
    if (!this.c.value) {
      return;
    }
    if (this.c.max && this.c.value > this.c.max) {
      if (this.c.maxTip) {
        this.$message.warning(this.c.maxTip);
      } else {
        this.$message.warning("数值不能大于" + this.c.max);
      }
      // 如果限制输入，需要清除当前的
      if (this.c.limit) {
        this.c.value = null;
        this.$forceUpdate();
        this.valueChange(this.c.value);
      }
      return;
    }
    if (this.c.min && this.c.value < this.c.min) {
      if (this.c.minTip) {
        this.$message.warning(this.c.minTip);
      } else {
        this.$message.warning("数值不能小于" + this.c.max);
      }
      // 如果限制输入，需要清除当前的
      if (this.c.limit) {
        this.c.value = null;
        this.$forceUpdate();
        this.valueChange(this.c.value);
      }
      return;
    }
    if (this.c.precision || this.c.precision === 0) {
      const numStr = this.c.value.toString();
      const decimalPart = numStr.split(".")[1];
      const decimalLength = decimalPart ? decimalPart.length : 0;
      if (decimalLength !== this.c.precision) {
        if (this.c.precision === 0) {
          this.$message.warning("请输入整数");
        } else {
          this.$message.warning("请保留" + this.c.precision + "位小数");
        }
        // 如果限制输入，需要清除当前的
        if (this.c.limit) {
          this.c.value = null;
          this.$forceUpdate();
          this.valueChange(this.c.value);
        }
      }
    }
  }
  private openDialog() {
    if (this.c.template) {
      this.zhengzhuangfenjiData = JSON.parse(JSON.stringify(this.c.template));
    } else {
      this.zhengzhuangfenjiData = [
        {
          title: "关节疼痛",
          options: [
            {
              label: "无疼痛",
              value: 0,
            },
            {
              label: "尚能忍受，或仅劳累或天气变化时疼痛，基本不影响工作",
              value: 1,
            },
            {
              label: "较重，工作和休息均受影响",
              value: 2,
            },
            {
              label: "严重，难以忍受，严重影响工作和休息，需服用止痛药",
              value: 3,
            },
          ],
          value: "",
        },
        {
          title: "关节肿胀",
          options: [
            {
              label: "无肿胀",
              value: 0,
            },
            {
              label: "轻度肿胀，皮肤纹理变浅，关节的骨标志仍明显",
              value: 1,
            },
            {
              label: "肿胀明显，皮肤纹理基本消失，骨标志不明显",
              value: 2,
            },
            {
              label: "重度肿胀，皮肤纹理消失，骨标志消失",
              value: 3,
            },
          ],
        },
        {
          title: "发热",
          options: [
            {
              label: "无",
              value: 0,
            },
            {
              label: "面微赤，体温37~37.9°C",
              value: 1,
            },
            {
              label: "面热赤，体温38~38.9°C",
              value: 2,
            },
            {
              label: "肌肤灼热,体温39°C以上",
              value: 3,
            },
          ],
        },
        {
          title: "关节牙痛",
          options: [
            {
              label: "无压痛",
              value: 0,
            },
            {
              label: "轻度压痛，患者称有痛感",
              value: 1,
            },
            {
              label: "中度压痛，尚能忍受，皱眉不适等",
              value: 2,
            },
            {
              label: "重度压痛，痛不可触，压挤关节时患者很痛，将手或肢体缩回",
              value: 3,
            },
          ],
        },
        {
          title: "关节屈伸不利",
          options: [
            {
              label: "关节活动正常",
              value: 0,
            },
            {
              label: "关节活动轻度受限，关节活动范围减少<1/3",
              value: 1,
            },
            {
              label: "关节活动明显受限，关节活动范围减少≥1/3",
              value: 2,
            },
            {
              label: "关节活动严重受限，关节活动范围减少≥2/3，甚或僵直",
              value: 3,
            },
          ],
        },
        {
          title: "关节发热",
          options: [
            {
              label: "无",
              value: 0,
            },
            {
              label: "关节触之微热，自觉不热",
              value: 1,
            },
            {
              label: "关节触之热，自觉亦热",
              value: 2,
            },
            {
              label: "关节触之热，且自觉灼热",
              value: 3,
            },
          ],
        },
        {
          title: "关节作冷",
          options: [
            {
              label: "无",
              value: 0,
            },
            {
              label: "仅关节恶风寒，触之不凉",
              value: 1,
            },
            {
              label: "关节恶风寒，触之凉，喜温",
              value: 2,
            },
            {
              label: "关节恶风寒明显，常衣保护",
              value: 3,
            },
          ],
        },
        {
          title: "口渴",
          options: [
            {
              label: "无",
              value: 0,
            },
            {
              label: "口干微欲饮，饮水量不多",
              value: 1,
            },
            {
              label: "口干欲饮，饮水量较多",
              value: 2,
            },
            {
              label: "口中烦躁，时时歌饮，饮水量多",
              value: 3,
            },
          ],
        },
        {
          title: "汗出",
          options: [
            {
              label: "偶有汗出多",
              value: 1,
            },
            {
              label: "经常汗出，动则汗出",
              value: 2,
            },
            {
              label: "汗出较多，常湿衣襟",
              value: 3,
            },
          ],
        },
        {
          title: "畏恶风寒",
          options: [
            {
              label: "无",
              value: 0,
            },
            {
              label: "偶有畏恶风寒",
              value: 1,
            },
            {
              label: "经常畏恶风寒，不需加衣",
              value: 2,
            },
            {
              label: "关节畏恶风寒明星，常加衣保护",
              value: 3,
            },
          ],
        },
        {
          title: "肢冷不温",
          options: [
            {
              label: "自觉时冷，但触之不凉",
              value: 1,
            },
            {
              label: "经常自觉冷，触之凉",
              value: 2,
            },
            {
              label: "肢冷重伴有疼痛",
              value: 3,
            },
          ],
        },
        {
          title: "腰膝酸软",
          options: [
            {
              label: "无",
              value: 0,
            },
            {
              label: "微酸软，或时有时无",
              value: 1,
            },
            {
              label: "酸软明显，时轻时重",
              value: 2,
            },
            {
              label: "酸软甚，转侧不利",
              value: 3,
            },
          ],
        },
        {
          title: "晨僵",
          options: [
            {
              label: "无",
              value: 0,
            },
            {
              label: "晨僵<1个小时",
              value: 1,
            },
            {
              label: "1个小时≤晨僵<2个小时",
              value: 2,
            },
            {
              label: "展僵≥2个小时",
              value: 3,
            },
          ],
        },
      ];
    }
    this.ifShowDialog = true;
  }
  private save() {
    for (let i = 0; i < this.zhengzhuangfenjiData.length; i++) {
      const item = this.zhengzhuangfenjiData[i];
      if (!item.value && item.value !== 0) {
        this.$message.warning("请选择" + item.title + "情况");
        return;
      }
    }
    // 算分
    let score: any = 0;
    this.zhengzhuangfenjiData.forEach((ele: any) => {
      score += ele.value;
    });
    this.c.value = score;
    this.c.template = this.zhengzhuangfenjiData;
    this.valueChange();
    this.ifShowDialog = false;
  }
}
